import { render, staticRenderFns } from "./ClinicMsg.vue?vue&type=template&id=131c9a4f&scoped=true"
import script from "./ClinicMsg.vue?vue&type=script&lang=js"
export * from "./ClinicMsg.vue?vue&type=script&lang=js"
import style0 from "./ClinicMsg.vue?vue&type=style&index=0&id=131c9a4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131c9a4f",
  null
  
)

export default component.exports